// IntersectionObserver でスクロール表示を検知
document.addEventListener("DOMContentLoaded", () => {
  const targets = document.querySelectorAll('.fadein');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-show'); // 表示されたらアニメ開始
      }
    });
  }, { threshold: 0.1 });

  targets.forEach(target => observer.observe(target));
});
